var _ = {
    uniqBy: require('lodash/uniqBy')
};

/**
 * Group locations by type include related official locations.
 */
function collectLocationsByType(locations, includeRelatedTowns) {
    if (!locations || !Array.isArray(locations) || !locations.length) {
        return {};
    }


    var insertLocation = function(acc, location, type) {
        type = type || location.type;

        acc[type] = !acc[type] ? [ location ] : acc[type].concat(location);

        return acc;
    };

    var locationsByType = locations.reduce(function(acc, location) {
        insertLocation(acc, location);

        var relatedOfficialLocations = [ 'city', 'district' ].concat(includeRelatedTowns ? 'town' : []);

        relatedOfficialLocations.forEach(function(type) {
            var relatedLocation = location[type];

            if (!relatedLocation) {
                return;
            }

            Array.isArray(relatedLocation) ? relatedLocation.forEach(function(l) {
                insertLocation(acc, l, type);
            }) : insertLocation(acc, relatedLocation, type);
        });

        return acc;
    }, {});

    Object.keys(locationsByType).forEach(function(type) {
        locationsByType[type] = _.uniqBy(locationsByType[type], 'id');
    });

    return locationsByType;
}

function getTheMostPrecedentLocations(locations) {
  var theMostPrecedentLocations = [];

  /*
   * Add all locations to precedent locations
   */
  locations.forEach(function(location) {
    theMostPrecedentLocations.push(location);
  });

  /*
   * Remove cities and districts for towns, from precedent locations
   * Remove cities for districts, from precedent locations
   */
  locations.forEach(function(location) {
    var relatedLocations = getRelatedLocations(location);

    relatedLocations.forEach(function(relatedLocation) {
      var locationToRemove = theMostPrecedentLocations.findIndex(function(precedentLocation, index) {
        return precedentLocation.id === relatedLocation;
      });

      if (locationToRemove !== -1) {
        theMostPrecedentLocations.splice(locationToRemove, 1);
      };
    });
  });

  return theMostPrecedentLocations;
}

function getRelatedLocations(location) {
  var relatedLocations = [];
  var cities = [];
  var districts = [];
  var towns = [];

  /*
   * Extract city id(s) from location
   */
  if (location.city && location.type !== 'city' && Array.isArray(location.city)) {
    location.city.forEach(function(city) {
      cities.push(city.id);
    });
  } else if (location.city && location.type !== 'city') {
    cities.push(location.city.id);
  };

  /*
   * Extract district id(s) from location
   */
  if (location.district && location.type !== 'district' && Array.isArray(location.district)) {
    location.district.forEach(function(district) {
      districts.push(district.id);
    });
  } else if (location.district && location.type !== 'district') {
    districts.push(location.district.id);
  }

  if (location.town && (location.type === 'poi' || location.type === 'project')) {
      if(Array.isArray(location.town)){
          location.town.forEach(function(town) {
              towns.push(town.id);
          });
      } else {
          towns.push(location.town.id);
      }
  }

  relatedLocations = cities.concat(districts, towns);

  return relatedLocations;
}


/**
 * Calculates the distance (in meters) between two coordinates using the Haversine formula.
 *
 * @param {*} a
 * @param {*} b
 */
function getHaversineDistance(a, b) {
  const PI_360 = Math.PI / 360;
  const R = 6378137;
  const cLat = Math.cos((a.lat + b.lat) * PI_360);
  const dLat = (b.lat - a.lat) * PI_360;
  const dLon = (b.lon - a.lon) * PI_360;

  const f = dLat * dLat + cLat * cLat * dLon * dLon;
  const c = 2 * Math.atan2(Math.sqrt(f), Math.sqrt(1 - f));

  return R * c;
}

/**
* Returns true if the location's type is one of city, district, locality, town, region or subregion.
*/
function isBoundaryLocationType(location) {
  return location.type === 'city' ||
         location.type === 'district' ||
         location.type === 'locality' ||
         location.type === 'town' ||
         location.type === 'region' ||
         location.type === 'subregion';
}

module.exports = {
    collectLocationsByType: collectLocationsByType,
    getTheMostPrecedentLocations: getTheMostPrecedentLocations,
    getHaversineDistance: getHaversineDistance,
    isBoundaryLocationType: isBoundaryLocationType
};
